import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const adminStudioApi = createApi({
  reducerPath: "studios",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["studios", "group"],
  endpoints: (builder) => ({
    getStudios: builder.query({
      query: ({ startRow, endRow, value = "", adminId = "" }) => ({
        url: `/admin/Studio/list?studioName=${value.toLowerCase()}&adminId=${adminId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { startRow, endRow },
      }),
      providesTags: ["studios"],
    }),
    getStudioId: builder.query({
      query: (studioId) => ({
        url: "admin/Studio/" + studioId,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["studios"],
    }),
    associaAdmin: builder.mutation({
      query: (admin) => ({
        url: `/admin/Studio/associateadmin`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: admin,
      }),
      invalidatesTags: ["studios"],
    }),
    disassociaAdmin: builder.mutation({
      query: (admin) => ({
        url: `/admin/Studio/removeadminfromstudio`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: admin,
      }),
      invalidatesTags: ["studios"],
    }),
    createStudio: builder.mutation({
      query: (studio) => ({
        url: `/admin/Studio`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: studio,
      }),
      invalidatesTags: ["studios"],
    }),
    deleteLogoStudio: builder.mutation({
      query: (studio) => ({
        url: `/admin/studio/${studio.id}/deletelogo`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: studio,
      }),
      invalidatesTags: ["studios"],
    }),
    deleteStudio: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/Studio/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { id },
      }),
      invalidatesTags: ["studios"],
    }),
    saveStudio: builder.mutation({
      query: (studio) => ({
        url: `admin/Studio/updatestudio`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: studio,
      }),
      invalidatesTags: ["studios"],
    }),
    getGroupStudio: builder.query({
      query: (adminId) => ({
        url: `admin/AdminStudioGroup/list/${adminId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["group"],
    }),
    getGroupId: builder.query({
      query: (id) => ({
        url: `admin/AdminStudioGroup/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["group"],
    }),
    createGroupStudio: builder.mutation({
      query: ({ groupName, adminId }) => ({
        url: `admin/AdminStudioGroup?groupName=${groupName}&adminId=${adminId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "studios"],
    }),
    deleteGroupStudio: builder.mutation({
      query: ({ id }) => ({
        url: `admin/AdminStudioGroup/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "studios"],
    }),
    editGroupStudio: builder.mutation({
      query: ({ id, groupName, adminId }) => ({
        url: `admin/AdminStudioGroup/${id}?groupName=${groupName}&adminId=${adminId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "studios"],
    }),
    addStudioGroup: builder.mutation({
      query: ({ studioId, groupId }) => ({
        url: `admin/AdminStudioGroup/api/admin/add-studio?studioId=${studioId}&groupId=${groupId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "studios"],
    }),
    removeStudioGroup: builder.mutation({
      query: ({ studioId, groupId }) => ({
        url: `admin/AdminStudioGroup/api/admin/remove-studio?studioId=${studioId}&groupId=${groupId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["group", "studios"],
    }),
  }),
});

export const {
  useGetStudiosQuery,
  useGetStudioIdQuery,
  useCreateStudioMutation,
  useAssociaAdminMutation,
  useDeleteStudioMutation,
  useSaveStudioMutation,
  useDisassociaAdminMutation,
  useGetGroupStudioQuery,
  useGetGroupIdQuery,
  useCreateGroupStudioMutation,
  useEditGroupStudioMutation,
  useDeleteGroupStudioMutation,
  useAddStudioGroupMutation,
  useRemoveStudioGroupMutation
} = adminStudioApi;
